import React from "react"
import { Route, Redirect } from "react-router-dom"
import { useAuth } from '../../contexts/AuthContext'

export default function AdminRoute({ component: Component, ...rest }) {
  const { currentUser,currentAdmin } = useAuth()



  return (
    <Route
      {...rest}
      render={props => {
        return currentAdmin ? (
          currentUser? <Component {...props} /> : <Redirect to="/login" />
        ) :
        (        
        <> 
          <div>
            <h1>You do not have admin rights </h1>
          </div>                  
        </>)
      }}
    ></Route>
  )
}
